export const gridDefaultColDef = {
  filter: 'agSetColumnFilter',
  resizable: true,
  sortable: true,
};

export const gridColumns = [
  {
    headerName: 'Forename',
    field: 'firstName',
    minWidth: 125,
  },
  {
    headerName: 'Surname',
    field: 'lastName',
    minWidth: 150,
  },
  {
    headerName: 'Role(s)',
    field: 'roles',
    minWidth: 200,
    valueGetter: params => params.data.roles.map(role => role.name),
  },
  {
    headerName: 'Team(s)',
    field: 'teams',
    minWidth: 150,
    valueGetter: params => params.data.teams.map(team => team.team),
  },
];
